import { API_SIGNATURE_URL } from "../../../config";

import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const signatureConstants = {
  GET_DOCUMENTS_TO_SIGN_START: "GET_DOCUMENTS_TO_SIGN_START",
  GET_DOCUMENTS_TO_SIGN_SUCCESS: "GET_DOCUMENTS_TO_SIGN_SUCCESS",
  GET_DOCUMENTS_TO_SIGN_ERROR: "GET_DOCUMENTS_TO_SIGN_ERROR",

  SIGN_START: "SIGN_START",
  SIGN_SUCCESS: "SIGN_SUCCESS",
  SIGN_ERROR: "SIGN_ERROR",

  GET_DOCUMENTS_SIGNED_START: "GET_DOCUMENTS_SIGNED_START",
  GET_DOCUMENTS_SIGNED_SUCCESS: "GET_DOCUMENTS_SIGNED_SUCCESS",
  GET_DOCUMENTS_SIGNED_ERROR: "GET_DOCUMENTS_SIGNED_ERROR"
};

export function getDocumentsToSign(
  page, size, isAppend = false
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantIdSelected = main.accountantIdSelected;
    const companyId = main.clientIdSelected;

    let request = {
      method: "POST",
      url: `${API_SIGNATURE_URL}/documents/search?page=${page}&size=${size}`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
      data: {
        documentIntermediaryId: accountantIdSelected,
        documentStatusId: "aa3b038e-8de4-4404-bf42-010fdcf24808",
        documentOwnerId: companyId,
        signerEmail: auth.loginAuth.id
      }
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: signatureConstants.GET_DOCUMENTS_TO_SIGN_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: signatureConstants.GET_DOCUMENTS_TO_SIGN_SUCCESS,
              payload: {
                data: result.data,
                isAppend: isAppend
              }
            });
          } else if (result.status === 403) {
            reject();
          } else {
            dispatch({
              type: signatureConstants.GET_DOCUMENTS_TO_SIGN_ERROR,
              error: result.data
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: signatureConstants.GET_DOCUMENTS_TO_SIGN_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function signDocument(auth, hubId) {
  let request = {
    method: "GET",
    url: `${API_SIGNATURE_URL}/documents/${hubId}`,
    headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
  };

  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: signatureConstants.SIGN_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: signatureConstants.SIGN_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: signatureConstants.SIGN_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: signatureConstants.SIGN_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
